<template>
  <div class="row">
    <div class="col-6 offset-3">

      <div class="m-portlet">

        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">

              <span class="m-portlet__head-icon m--hide">
                <i class="la la-gear"></i>
              </span>

              <h3 class="m-portlet__head-text">
                Register
              </h3>

            </div>
          </div>
        </div>

        <div class="m-portlet__body">
          <form class="mt-3" @submit.prevent="onSubmit">

            <div class="alert alert-danger" v-if="errors.length">
              <ul class="m-0">
                <li v-for="error in errors">{{ error }}</li>
              </ul>
            </div>

            <div class="form-group">
              <label for="name">Name</label>
              <input type="text"
                     class="form-control"
                     id="name"
                     v-model="name">
            </div>

            <div class="form-group">
              <label for="email">Email</label>
              <input type="email"
                     class="form-control"
                     id="email"
                     v-model="email">
            </div>

            <div class="form-group">
              <label for="password">Password</label>
              <input type="password"
                     class="form-control"
                     id="password"
                     v-model="password">
            </div>

            <div class="form-group">
              <label for="password_confirmation">Repeat password</label>
              <input type="password"
                     class="form-control"
                     id="password_confirmation"
                     v-model="confirmPassword">
            </div>

            <button type="submit" class="btn btn-dark">Register</button>

          </form>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import {mapActions} from 'vuex'

  export default {
    data() {
      return {
        email: '',
        name: '',
        password: '',
        confirmPassword: '',
        errors: []
      }
    },

    methods: {
      ...mapActions('auth', ['login']),
      onSubmit() {
        this.errors = [];
        const formData = {
          email: this.email,
          name: this.name,
          gender: this.gender,
          country: this.country,
          password: this.password,
          password_confirmation: this.confirmPassword
        }

        this.axios.post('/register', formData)
          .then(res => {
            this.login(res.data)
          })
          .catch(res => {
            const errors = res.response.data.errors;
            Object.keys(errors).forEach(key => {
              this.errors = this.errors.concat(errors[key])
            })
          })
      }
    },
  }
</script>




// WEBPACK FOOTER //
// src/views/Auth/RegisterPage.vue